import type { UserSavedSearch } from "@/modules/jobAds/client/api/types"

import { useState } from "react"

import { ADD_USER_MONO_SAVED_SEARCH_ENDPOINT } from "@/modules/jobAds/client/api/constants"
import { createUserSavedSearch } from "@/modules/jobAds/client/api/createUserSavedSearch"
import { computeUserSavedSearch } from "@/modules/jobAds/client/utils/computeUserSavedSearch"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { logger } from "@/modules/monitoring/logger"

type UseAddUserSavedSearchReturn = {
  addUserSavedSearch: (searchParams: UserSavedSearch["searchParams"]) => Promise<void>
  isLoading: boolean
}

export const useAddUserSavedSearch = (): UseAddUserSavedSearchReturn => {
  const { updateUserSavedSearch } = usePageContext()
  const [isLoading, setIsLoading] = useState(false)

  const addUserSavedSearch = async (searchParams: UserSavedSearch["searchParams"]): Promise<void> => {
    setIsLoading(true)

    const hasWrongStartDates = searchParams.startDates.some(startDate => startDate.includes("_00"))
    if (hasWrongStartDates) {
      logger.error(
        `An issue occurred while fetching ${ADD_USER_MONO_SAVED_SEARCH_ENDPOINT} endpoint from "job_ads_fo_index" module, POST method. Invalid StartDate : ${JSON.stringify(
          searchParams
        )}`
      )
    }

    return createUserSavedSearch({
      attributes: JSON.stringify(searchParams),
    })
      .then(({ savedSearch }) => {
        if (savedSearch) {
          updateUserSavedSearch?.(computeUserSavedSearch(savedSearch))
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return { addUserSavedSearch, isLoading }
}
